import { getFirestore, collection, doc, getDoc, getCountFromServer, query, where, orderBy, limit, onSnapshot, increment, runTransaction, Timestamp, } from "firebase/firestore";
import { mapFirebaseError } from "./errorMapper";
import { commentDTOtoDomain } from "./mappers";
export class FirebaseCommentsRepository {
    db = getFirestore();
    coll = collection(this.db, "comments");
    commentsStream(serviceId) {
        const q = query(this.coll, where("serviceId", "==", serviceId), orderBy("createdAt", "desc"), limit(50));
        let unsub = null;
        return {
            subscribe: (cb) => {
                unsub = onSnapshot(q, (snap) => {
                    const comments = snap.docs.map((d) => commentDTOtoDomain(d.id, d.data()));
                    cb(comments);
                }, (error) => {
                    throw mapFirebaseError(error);
                });
                return () => { unsub?.(); };
            },
            unsubscribe: () => { unsub?.(); },
        };
    }
    async add(input) {
        try {
            await runTransaction(this.db, async (tx) => {
                const commentRef = doc(this.coll);
                tx.set(commentRef, {
                    ...input,
                    createdAt: Timestamp.now(),
                });
                const serviceRef = doc(this.db, "services", input.serviceId);
                tx.update(serviceRef, { commentCount: increment(1) });
            });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async delete(comment) {
        try {
            await runTransaction(this.db, async (tx) => {
                tx.delete(doc(this.coll, comment.id));
                const serviceRef = doc(this.db, "services", comment.serviceId);
                tx.update(serviceRef, { commentCount: increment(-1) });
            });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async count(serviceId) {
        try {
            const q = query(this.coll, where("serviceId", "==", serviceId));
            const snap = await getCountFromServer(q);
            return snap.data().count;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchById(id) {
        try {
            const snap = await getDoc(doc(this.coll, id));
            if (!snap.exists())
                return null;
            return commentDTOtoDomain(snap.id, snap.data());
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseCommentsRepository.js.map